import type { IconProps } from './types'

export const FlagEsIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 64 48"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="48" rx="8" fill="#AA151B" />
      <path d="M0 12H64V36H0Z" fill="#F1BF00" />
      <circle cx="20" cy="24" r="5" fill="#AA151B" opacity="0.7" />
    </svg>
  )
}
